// Formatting for the account screens. Everything here runs the same on the server and in the browser,
// so the server-rendered text matches hydration.
import dayjs from "dayjs";
import "dayjs/locale/fa";
import relativeTime from "dayjs/plugin/relativeTime";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";
import jalali from "jalaliday";
import toPersianDigits from "~/utils/toPersianDigits";

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(relativeTime);
dayjs.extend(jalali);

// Persian digits, no thousands separators (phone numbers, ids, dates, versions).
export const faDigits = (value: string | number) => toPersianDigits(String(value), { maximumFractionDigits: 0, toLocaleString: false });

// jalaliday drops the tz offset, so re-read the Tehran wall time as local time before switching calendars.
export const faDate = (value: string, format = "D MMMM YYYY") =>
  faDigits(dayjs(dayjs(value).tz("Asia/Tehran").format("YYYY-MM-DDTHH:mm:ss")).calendar("jalali").locale("fa").format(format));

// `now` comes from loader data so the server and hydration render the same string, whatever the device clock says.
export const faFromNow = (value: string, now: number) => faDigits(dayjs(value).locale("fa").from(now));

// 09123456789 or 9123456789 reads as 0912 345 6789; anything else is shown as typed.
export function formatMobile(number?: string) {
  const m = /^0?(9\d{2})(\d{3})(\d{4})$/.exec(number ?? "");
  return faDigits(m ? `0${m[1]} ${m[2]} ${m[3]}` : number ?? "");
}

if (import.meta.env?.DEV) {
  console.assert(formatMobile("9123456789") === "۰۹۱۲ ۳۴۵ ۶۷۸۹" && formatMobile("+4915112345678") === "+۴۹۱۵۱۱۲۳۴۵۶۷۸", "formatMobile self-check failed");
  console.assert(faDate("2026-08-13T21:30:00.000Z", "D MMMM YYYY HH:mm") === "۲۳ مرداد ۱۴۰۵ ۰۱:۰۰", "faDate self-check failed", faDate("2026-08-13T21:30:00.000Z", "D MMMM YYYY HH:mm"));
}
